import Api from "~/service/Api";

class PageRepository {
  fetch(query) {
    return Api.get("/pages", query);
  }

  delete(pageId) {
    return Api.delete(`/pages/${pageId}`);
  }

  create(data) {
    return Api.post("/pages", data);
  }

  update(pageId, data) {
    return Api.put(`/pages/${pageId}`, data);
  }

  fetchOne(pageId) {
    return Api.get(`/pages/${pageId}`);
  }
}

export default PageRepository;
